import React from 'react';
import { SimplePage } from '../components/shared/SharedComponents';
import {
  LegalPageContent,
  LegalLastUpdated,
  LegalSection,
  LegalSectionTitle,
  LegalParagraph,
  LegalSubsectionTitle,
  renderLegalContent,
} from '../components/legal/legalPagePrimitives';
import { useContent } from '../hooks/useContent';

function LegalNotice() {
  const { legalNotice } = useContent();

  const title = legalNotice?.title || 'Legal Notice';
  const description = legalNotice?.description || '';
  const lastUpdated = legalNotice?.lastUpdated;
  const lastUpdatedLabel = legalNotice?.lastUpdatedLabel || 'Last updated:';
  const emptyContentMessage = legalNotice?.emptyContentMessage || 'Our legal notice will be published here soon. Until then, feel free to reach out with any questions.';
  const sections = Array.isArray(legalNotice?.sections) ? legalNotice.sections : [];

  return (
    <SimplePage title={title} description={description}>
      <LegalPageContent>
        {lastUpdated && <LegalLastUpdated>{lastUpdatedLabel} {lastUpdated}</LegalLastUpdated>}

        {sections.length > 0 ? (
          sections.map((section, sectionIndex) => (
            <LegalSection key={`${section?.title || 'section'}-${sectionIndex}`}>
              {section?.title && <LegalSectionTitle>{section.title}</LegalSectionTitle>}

              {renderLegalContent(section?.paragraphs)}

              {Array.isArray(section?.subsections) && section.subsections.length > 0 && (
                <div>
                  {section.subsections.map((subsection, subsectionIndex) => {
                    const isEmptyTitle = !subsection?.title || subsection.title === '';
                    return (
                      <div key={`${subsection?.title || 'sub'}-${subsectionIndex}`} style={{ marginTop: isEmptyTitle ? '16px' : '28px' }}>
                        {subsection?.title && <LegalSubsectionTitle>{subsection.title}</LegalSubsectionTitle>}
                        {renderLegalContent(subsection?.paragraphs, isEmptyTitle)}
                      </div>
                    );
                  })}
                </div>
              )}

              {Array.isArray(section?.paragraphsAfter) && section.paragraphsAfter.length > 0 && (
                <div style={{ marginTop: '16px' }}>
                  {renderLegalContent(section.paragraphsAfter)}
                </div>
              )}
            </LegalSection>
          ))
        ) : (
          <LegalParagraph>
            {emptyContentMessage}
          </LegalParagraph>
        )}
      </LegalPageContent>
    </SimplePage>
  );
}

export default LegalNotice;

